export default __webpack_public_path__ + "static/media/blood-pressure-control-tool.2552f81f.png";